import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../../common/hoc/clientOnly';

const App = lazy(() =>
  import(/* webpackChunkName: "CastingHouses" */ './CastingHouses')
);

const CastingHouses = props => (
  <Suspense fallback={null}>
    <App {...props} />
  </Suspense>
);

export default clientOnly(CastingHouses);
